"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var FormLabel_1 = require("../FormLabel");
var hocs_1 = require("../hocs");
var StyledTextInput_1 = require("../TextInput/StyledTextInput");
var withFormFields_hoc_1 = require("../withFormFields/withFormFields.hoc");
var RadioContext_1 = require("./RadioContext");
var RadioGroupInner = function (props) {
    var children = props.children, label = props.label, theme = props.theme, onChange = props.onChange, value = props.value, error = props.error, errorIcon = props.errorIcon, errorMessage = props.errorMessage, id = props.id, rest = tslib_1.__rest(props, ["children", "label", "theme", "onChange", "value", "error", "errorIcon", "errorMessage", "id"]);
    var handleChange = function (event) {
        if (onChange) {
            onChange(event, event.target.value);
        }
    };
    var context = tslib_1.__assign({ onChange: handleChange, value: value, id: id }, rest);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && (react_1.default.createElement(FormLabel_1.FormLabel, { "aria-invalid": !!error },
            label,
            " ",
            error && errorIcon)),
        react_1.default.createElement(RadioContext_1.RadioContext.Provider, { value: context }, children),
        error && (react_1.default.createElement(StyledTextInput_1.StyledError, { theme: theme, id: id && "error-" + id }, errorMessage))));
};
/** @component */
exports.RadioGroup = recompose_1.compose(styled_components_1.withTheme, hocs_1.withForwardRef)(RadioGroupInner);
/** @component */
exports.FormRadioGroup = withFormFields_hoc_1.withFormFields(RadioGroupInner);
//# sourceMappingURL=RadioGroup.js.map